// mantine
import { Tooltip, UnstyledButton } from '@mantine/core';
// icons
import { Info as InfoIcon } from 'lucide-react';
import styles from '@/modules/Chat/components/Message/components/Header/components/Info/Info.module.css';

interface InfoProps {
    className?: string;
    integrationIdn: string | null;
    connectorIdn: string | null;
    externalId: string | null;
    contactInformation: string | null;
}

const Info = ({
    className,
    integrationIdn,
    connectorIdn,
    externalId,
    contactInformation
}: InfoProps) => {
    return (
        <Tooltip
            withArrow
            arrowSize={4}
            label={
                <div className={styles.grid}>
                    <div>Integration:</div>
                    <div>{integrationIdn}</div>
                    <div>Connector:</div>
                    <div>{connectorIdn}</div>
                    <div>External ID:</div>
                    <div>{externalId}</div>
                    <div>Contact Info:</div>
                    <div>{contactInformation}</div>
                </div>
            }
        >
            <UnstyledButton className={className}>
                <InfoIcon />
            </UnstyledButton>
        </Tooltip>
    );
};

export default Info;
